import React from 'react';
import { LinearProgress } from '@material-ui/core';
import useStyles, { StyledLabel, StyledProgressBarContainer } from './ProgressBar.styles';

export type ColorProps = 'primary' | 'secondary';
export type VariantProps = 'determinate' | 'indeterminate';

export interface ProgressBarProps {
  value?: number;
  label?: string;
  color?: ColorProps;
  dataQaId?: string;
  variant?: VariantProps;
  noBackground?: boolean;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  value = 0,
  label,
  color = 'primary',
  noBackground = false,
  dataQaId,
  variant = 'determinate',
}: ProgressBarProps) => {
  const classes = useStyles({ noBackground });

  return (
    <StyledProgressBarContainer data-qa-id={`${dataQaId}-container`}>
      {label && <StyledLabel data-qa-id={`${dataQaId}-label`}>{label}</StyledLabel>}
      <LinearProgress classes={classes} value={value} data-qa-id={dataQaId} variant={variant} color={color} />
    </StyledProgressBarContainer>
  );
};

export default ProgressBar;
